<!-- 疾病危険度パネル -->
<template>
  <div class="panel">
    <img :src="panel" alt="disease-risk-card" :data-test="`${dataTest}Panel`" />
  </div>
</template>

<script>
import VueTypes from "vue-types";

import Normal from "../../../../static/svg/panel_normal.svg";
import Caution from "../../../../static/svg/panel_caution.svg";
import Risk from "../../../../static/svg/panel_risk.svg";
import HighRisk from "../../../../static/svg/panel_highrisk.svg";
import NormalOff from "../../../../static/svg/panel_normal_off.svg";
import CautionOff from "../../../../static/svg/panel_caution_off.svg";
import RiskOff from "../../../../static/svg/panel_risk_off.svg";
import HighRiskOff from "../../../../static/svg/panel_highrisk_off.svg";

export default {
  props: {
    riskIndex: VueTypes.number.isRequired,
    diseaseHistory: VueTypes.bool.isRequired,
    dataTest: VueTypes.string
  },
  data() {
    return {
      Normal: Normal,
      Caution: Caution,
      Risk: Risk,
      HighRisk: HighRisk,
      NormalOff: NormalOff,
      CautionOff: CautionOff,
      RiskOff: RiskOff,
      HighRiskOff: HighRiskOff
    };
  },
  computed: {
    panel: function() {
      if (this.diseaseHistory) {
        switch (this.riskIndex) {
          case 0:
            return this.NormalOff;
          case 1:
            return this.CautionOff;
          case 2:
            return this.RiskOff;
          case 3:
            return this.HighRiskOff;
        }
      } else {
        switch (this.riskIndex) {
          case 0:
            return this.Normal;
          case 1:
            return this.Caution;
          case 2:
            return this.Risk;
          case 3:
            return this.HighRisk;
        }
      }
    }
  }
};
</script>

<style scoped>
.panel {
  width: 100%;
  height: 100%;
}
.panel > img {
  object-fit: cover;
}

</style>
